module.exports = __webpack_public_path__ + "img/address-title.d59e4a29.png";